document.addEventListener('wheel', (event) => {
  const target = event.target;
  if (target instanceof HTMLInputElement && target.type === 'number') {
    target.blur();
  }
}, { passive: true });
